export default function NotificationsIcon({
  width = 20,
  height = 20,
  color = "#AEAFB0",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5765 16C10.8101 16 11.0001 16.1893 11.0003 16.4229C11.0003 16.4735 10.991 16.5243 10.972 16.5713C10.5147 17.6989 9.35671 18.4999 8.00034 18.5C6.6438 18.5 5.48505 17.699 5.02768 16.5713C5.00868 16.5243 5.00034 16.4735 5.00034 16.4229C5.00057 16.1893 5.18959 16 5.42319 16H10.5765ZM8.00034 0.5C11.2292 0.500187 13.9465 2.99092 14.3206 6.29395L14.6654 9.33887C14.7511 10.0951 15.0575 10.8068 15.5443 11.3799C16.5776 12.5961 15.7393 14.4997 14.1703 14.5H1.83041C0.261091 14.5 -0.577993 12.5962 0.455413 11.3799C0.942261 10.8068 1.24856 10.0952 1.33432 9.33887L1.68002 6.29395C2.05427 2.99083 4.77132 0.5 8.00034 0.5Z"
        fill={color}
      />
    </svg>
  );
}
